import React from "react";

export const Location = (props) => {
    const width = props.width ? props.width : "16";
    const height = props.height ? props.height : "16";
    const color = props.color ? props.color : "#091b29";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
        >
            <defs>
                <clipPath id="clip-path">
                    <rect id="Rectangle_48450" data-name="Rectangle 48450" width="16" height="16" transform="translate(257 136)" fill="#091b29" />
                </clipPath>
            </defs>
            <g id="Group_96361" data-name="Group 96361" transform="translate(-257 -136)">
                <g id="Mask_Group_6285" data-name="Mask Group 6285" clip-path="url(#clip-path)">
                    <path id="icons8-location_1_" data-name="icons8-location (1)" d="M8.325,1.6A5.521,5.521,0,0,0,4.13,10.716c.1.111,2.414,2.743,3.187,3.48a1.458,1.458,0,0,0,2.015,0c.9-.858,3.1-3.375,3.191-3.486a5.521,5.521,0,0,0-4.2-9.11Zm0,7.15A1.625,1.625,0,1,1,9.95,7.125,1.625,1.625,0,0,1,8.325,8.75Z" transform="translate(256.2 135.4)"
                        fill={color}
                    />
                </g>
            </g>
        </svg>
    );
};

